import React from 'react';
import PropTypes from 'prop-types';
import SaleIcon from 'mdi-react/SaleIcon';
import PercentIcon from 'mdi-react/PercentIcon';
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon';
import QrcodeIcon from 'mdi-react/QrcodeIcon';
import CalendarRangeIcon from 'mdi-react/CalendarRangeIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import BellRingOutlineIcon from 'mdi-react/BellRingOutlineIcon';
import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon';
import CounterIcon from 'mdi-react/CounterIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import MessageTextOutlineIcon from 'mdi-react/MessageTextOutlineIcon';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import exampleCurrency from '../../user_tiers/components/exampleCurrency';

/**
 * Offers in two steps: create one (as the club or for a partner, who can
 * also add their own in the app): price, audience, how it's used and
 * dates. Then fans activate it in the app and show the code, and the club
 * follows views and activations.
 */
const OffersShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  const currency = exampleCurrency(useConfig());
  return (
    <FeatureShowcase
      storageKey="offersShowcaseHidden"
      icon={SaleIcon}
      title={s('offersInfoTitle')}
      subtitle={s('offersShowcaseSubtitle')}
      showLabel={s('offersShowcaseShow')}
      uses={[
        {
          key: 'create',
          step: s('showcaseStep', { step: 1 }),
          icon: SaleIcon,
          label: s('offersCreateLabel'),
          text: s('offersCreateText'),
          cards: [
            {
              key: 'price',
              icon: PercentIcon,
              title: s('offersCardPrice'),
              text: s('offersCardPriceText', { currency }),
            },
            {
              key: 'audience',
              icon: AccountGroupOutlineIcon,
              title: s('offersCardAudience'),
              text: s('offersCardAudienceText'),
            },
            {
              key: 'use',
              icon: QrcodeIcon,
              title: s('offersCardUse'),
              text: s('offersCardUseText'),
            },
            {
              key: 'dates',
              icon: CalendarRangeIcon,
              title: s('offersCardDates'),
              text: s('offersCardDatesText'),
            },
          ],
        },
        {
          key: 'use',
          step: s('showcaseStep', { step: 2 }),
          icon: CellphoneIcon,
          label: s('offersUseLabel'),
          text: s('offersUseText'),
          items: [
            {
              key: 'push',
              icon: BellRingOutlineIcon,
              label: s('offersItemPush'),
            },
            {
              key: 'clock',
              icon: ClockOutlineIcon,
              label: s('offersItemClock'),
            },
            { key: 'limit', icon: CounterIcon, label: s('offersItemLimit') },
            { key: 'stats', icon: ChartBarIcon, label: s('offersItemStats') },
            {
              key: 'message',
              icon: MessageTextOutlineIcon,
              label: s('offersItemMessage'),
            },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

OffersShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

OffersShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default OffersShowcase;
